module.exports = __webpack_public_path__ + "img/400.room_link.d95eeeaa.svg";